import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectRankingCurrentPosition, selectRankingSelectedLanguage, } from "../../../selectors/selectRankInfo";
import { utilRanking } from "../../../utils/utilRanking";
import { actionPlayerXpHighscoresReceived, TypeActionRanking } from "../actionRanking";
export var epicPlayerXpRankingByPosition = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionRanking.PlayerXpHighSocresPositionRequest), switchMap(function (action) {
        var state = state$.value;
        var position = action.position
            ? action.position
            : selectRankingCurrentPosition(state);
        var language = selectRankingSelectedLanguage(state);
        var url = utilRanking.getRankingPlayerXpUrlByPosition(position, language ? language.languageCode : undefined);
        return utilRanking.ajaxGetRequest(url);
    }), retry(), switchMap(function (res) {
        return of(actionPlayerXpHighscoresReceived(res));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/epics/epicPlayerXpRankingByPosition.ts
// module id = 2122
// module chunks = 3